"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modality = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
const Modal_1 = require("../..");
class Modality extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.isScrollDisabled = false;
        this.prevBodyOverflow = '';
        this.prevContainerMaxHeight = '';
        this.prevContainerPosition = '';
        this.mainContentElement = null;
        this.hide = () => {
            const { onRequestClose } = this.props;
            if (onRequestClose) {
                onRequestClose();
                return;
            }
            this.internalHide();
        };
        this.show = () => {
            this.disableMainContent();
            this.addPositionForContainer();
            this.setState({
                isShown: true
            });
        };
        this.internalHide = () => {
            this.setState({
                isShown: false
            });
            this.enableMainContent();
            this.removePositionFromContainer();
        };
        this.state = {
            isShown: !!props.isShown
        };
    }
    addPositionForContainer() {
        const container = this.getParentDOMNodeWithScroll();
        const styles = getComputedStyle(container);
        const position = styles.position;
        if (!position || position === 'static') {
            this.prevContainerPosition = container.style.position;
            this.isPrevContainerPositionChanged = true;
            container.style.position = 'relative';
        }
    }
    removePositionFromContainer() {
        if (this.isPrevContainerPositionChanged) {
            this.getParentDOMNodeWithScroll().style.position = this.prevContainerPosition;
        }
    }
    disableContainerScroll() {
        const parentDOMNodeWithScroll = this.getParentDOMNodeWithScroll();
        this.isScrollDisabled = true;
        this.prevBodyOverflow = parentDOMNodeWithScroll.style.overflow;
        this.prevContainerMaxHeight = parentDOMNodeWithScroll.style.maxHeight;
        parentDOMNodeWithScroll.style.overflow = 'hidden';
        parentDOMNodeWithScroll.style.maxHeight = '100%';
    }
    enableContainerScroll() {
        if (this.isScrollDisabled) {
            this.getParentDOMNodeWithScroll().style.overflow = this.prevBodyOverflow;
            this.getParentDOMNodeWithScroll().style.maxHeight = this.prevContainerMaxHeight;
        }
    }
    getParentDOMNodeWithScroll() {
        if (!this.parentDOMNodeWithScroll) {
            this.parentDOMNodeWithScroll = this.getMainContainerElement() || document.body;
        }
        return this.parentDOMNodeWithScroll;
    }
    getPortalDOMNode() {
        return this.context.getPortalDomNode();
    }
    disableMainContent() {
        this.disableContainerScroll();
    }
    enableMainContent() {
        var _a;
        const prevModalEl = this.context.getPrevFromStack();
        if ((!prevModalEl && ((_a = this.context.getLastFromStack()) === null || _a === void 0 ? void 0 : _a.contains(this.getSelfNode()))) ||
            this.getMainContainerElement()) {
            this.enableContainerScroll();
        }
    }
    getMainContainerElement() {
        if (!this.props.containerRef) {
            return null;
        }
        if (!this.mainContentElement) {
            this.mainContentElement = this.props.containerRef.current;
        }
        return this.mainContentElement;
    }
    getSelfNode() {
        try {
            // eslint-disable-next-line react/no-find-dom-node
            return (0, react_dom_1.findDOMNode)(this);
        }
        catch (e) {
            return null;
        }
    }
    componentDidMount() {
        if (this.state.isShown) {
            this.disableMainContent();
            this.addPositionForContainer();
        }
    }
    getSnapshotBeforeUpdate(prevProps) {
        return { isShownPropsChanged: this.props.isShown !== prevProps.isShown };
    }
    componentDidUpdate(_, __, snapshot) {
        if (snapshot && snapshot.isShownPropsChanged) {
            if (this.props.isShown) {
                this.show();
            }
            else {
                this.internalHide();
            }
        }
    }
    componentWillUnmount() {
        if (this.state.isShown) {
            this.enableMainContent();
            this.removePositionFromContainer();
        }
    }
    render() {
        const { isShown } = this.state;
        const render = this.props.render || this.props.children;
        if (!render) {
            return null;
        }
        const injectedProps = {
            isShown,
            hide: this.hide
        };
        const portalDomNode = this.getMainContainerElement()
            ? this.getMainContainerElement()
            : this.getPortalDOMNode();
        if (!portalDomNode) {
            return null;
        }
        return (0, react_dom_1.createPortal)(isShown && render(Object.assign({}, injectedProps)), portalDomNode);
    }
}
exports.Modality = Modality;
Modality.contextType = Modal_1.ModalContext;
//# sourceMappingURL=Modality.js.map